(() => {
  const initialize = (section) => {
    if (!section || section.dataset.croFaqReady === "true") {
      return;
    }

    section.dataset.croFaqReady = "true";

    section
      .querySelectorAll("[data-cro-faq-trigger]")
      .forEach((button) => {
        button.addEventListener("click", () => {
          const answerId = button.getAttribute("aria-controls");
          const answer = document.getElementById(answerId);

          if (!answer) {
            return;
          }

          const open =
            button.getAttribute("aria-expanded") !== "true";

          button.setAttribute("aria-expanded", String(open));
          answer.hidden = !open;
        });
      });
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll("[data-cro-faq]").forEach(initialize);
  };

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      () => initializeAll(),
    );
  } else {
    initializeAll();
  }

  document.addEventListener(
    "shopify:section:load",
    (event) => initializeAll(event.target),
  );
})();
